import React, { useState } from "react";
import axios from "axios";
import swal from "sweetalert";

const KEY = "eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9";
const NODE_PRICE = 200;

const Checkout = () => {
  const [count, setCount] = useState(1);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [accepted, setAccepted] = useState(false);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const changeCount = (difference) => {
    setCount((previous) => Math.max(1, previous + difference));
    setErrors((previous) => ({ ...previous, amount: undefined }));
  };

  const displayError = (key) => {
    const error = errors?.[key];
    return Array.isArray(error) ? error.join(" ") : error || "";
  };

  const submit = async (event) => {
    event.preventDefault();
    if (submitting) return;
    if (!accepted) {
      setErrors((previous) => ({ ...previous, terms: "Please accept the Terms & Conditions." }));
      return;
    }
    if (!password.trim()) {
      setErrors((previous) => ({ ...previous, password: "Account password is required." }));
      return;
    }
    if (!localStorage.getItem("auth_token")) {
      swal("Warning", "Please log in to continue.", "warning");
      return;
    }
    setSubmitting(true);
    setErrors({});
    try {
      const { data } = await axios.post("/sub-node", {
        amount: count,
        password,
        key_s: KEY,
      });
      if (data?.status === "success") {
        swal("Success", data.message || "Node request submitted successfully.", "success");
        setCount(1);
        setPassword("");
        setAccepted(false);
      } else if (data?.status === "fail") {
        swal("Warning", data.message || "Unable to add nodes.", "warning");
      } else {
        setErrors(data?.validation_error || {});
        if (data?.message && !data?.validation_error) {
          swal("Warning", data.message, "warning");
        }
      }
    } catch (error) {
      swal("Error", error?.response?.data?.message || "Something went wrong. Please try again.", "error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="rm-node-root">
      <style>{`
        html,body,#root{background:#00191D!important;min-height:100%;}
        .rm-node-root{--navy:#00191D;--cyan:#16B8C7;--muted:#9db7bd;--border:rgba(22,184,199,.22);min-height:100vh;background:#00191D;color:#fff;padding:16px 4px 40px;font-size:14px;line-height:1.5;box-sizing:border-box}
        .rm-node-root *{box-sizing:border-box}
        .rm-node-wrap{width:100%;max-width:1120px;margin:0 auto}
        .rm-node-head{display:flex;align-items:center;justify-content:space-between;gap:14px;border:1px solid var(--border);background:linear-gradient(120deg,#073139,#00191D 75%);border-radius:18px;padding:20px 22px;margin-bottom:16px;animation:rmNodeIn .35s ease-out both}
        .rm-node-eyebrow{display:block;font-size:11px;letter-spacing:1.5px;text-transform:uppercase;font-weight:800;color:#69d9e2;margin-bottom:5px}
        .rm-node-head h1{font-size:24px;font-weight:800;color:#fff;margin:0 0 4px}
        .rm-node-head p{margin:0;color:#b4cdd1;font-size:14px}
        .rm-node-mark{width:52px;height:52px;border:1px solid #257984;background:rgba(22,184,199,.13);color:#6be3ed;border-radius:16px;display:grid;place-items:center;flex-shrink:0}
        .rm-node-mark svg{width:26px;height:26px}
        .rm-node-layout{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1.2fr);gap:16px;align-items:start}
        .rm-node-panel{border:1px solid var(--border);border-radius:18px;padding:22px;background:#04262c;min-width:0;animation:rmNodeIn .42s ease-out both}
        .rm-node-form{background:#fff;color:#122d33;border-color:#d8e9ec;animation-delay:.06s}
        .rm-node-title{display:flex;align-items:center;gap:10px;margin:0 0 18px;font-size:18px;font-weight:800;color:inherit}
        .rm-node-dot{width:9px;height:9px;background:#16B8C7;border-radius:50%;box-shadow:0 0 0 5px rgba(22,184,199,.13)}
        .rm-node-status{display:flex;justify-content:space-between;align-items:center;gap:12px;background:#0b3940;border:1px solid #1b525a;padding:15px;border-radius:13px;margin-bottom:14px}
        .rm-node-status strong{display:block;font-size:15px;color:#fff}.rm-node-status small{display:block;color:#a9c6ca;margin-top:3px;font-size:12px}
        .rm-node-pill{background:rgba(22,184,199,.16);border:1px solid #298e99;color:#8debf1;border-radius:30px;padding:6px 11px;font-size:12px;font-weight:800}
        .rm-node-stat-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:12px;margin-bottom:16px}
        .rm-node-stat{padding:16px;border-radius:13px;background:#07343b;border:1px solid #22525a}
        .rm-node-stat small{color:#a5c4c8;display:block;margin-bottom:7px;font-size:12px}
        .rm-node-stat strong{font-size:24px;line-height:1.2;font-weight:800;color:#fff;overflow-wrap:anywhere}
        .rm-node-stat.highlight{background:#e8fbfd;border-color:#c7eff3}.rm-node-stat.highlight small{color:#476970}.rm-node-stat.highlight strong{color:#087b88}
        .rm-node-info{display:flex;gap:10px;align-items:flex-start;border:1px solid #28535a;border-radius:12px;padding:13px;background:#072e34;color:#c5dce0;font-size:13px}
        .rm-node-info svg{width:19px;height:19px;flex-shrink:0;color:#5bd5e0}
        .rm-node-label{display:block;font-size:14px;font-weight:750;color:#173940;margin:0 0 8px}
        .rm-node-group{margin-bottom:20px}
        .rm-node-stepper{display:grid;grid-template-columns:54px minmax(0,1fr) 54px;overflow:hidden;border:1px solid #b9d9de;border-radius:13px;height:55px;background:#f6fcfd}
        .rm-node-stepper button{border:0;background:#e4f6f8;color:#077a86;font-size:23px;font-weight:700;cursor:pointer;transition:background .2s ease}
        .rm-node-stepper button:hover:not(:disabled){background:#bceef2}.rm-node-stepper button:disabled{opacity:.4;cursor:not-allowed}
        .rm-node-stepper output{display:grid;place-items:center;font-size:21px;font-weight:800;color:#102e34;border-left:1px solid #d3e6e9;border-right:1px solid #d3e6e9}
        .rm-node-hint{display:block;margin-top:7px;color:#6a868c;font-size:12px}
        .rm-node-password{display:flex;align-items:center;overflow:hidden;height:53px;border:1px solid #b9d9de;border-radius:12px;background:#f8fcfd;transition:border-color .2s ease}
        .rm-node-password:focus-within{border-color:#16B8C7;box-shadow:0 0 0 3px rgba(22,184,199,.12)}
        .rm-node-password input{width:100%;min-width:0;height:100%;background:transparent;border:0;outline:0;padding:0 14px;color:#18383e;font-size:14px}
        .rm-node-password button{border:0;background:transparent;padding:0 14px;color:#087d88;font-size:12px;font-weight:800;cursor:pointer;white-space:nowrap}
        .rm-node-terms{display:flex;align-items:flex-start;gap:10px;padding:14px;background:#f1f9fa;border:1px solid #d9e9ec;border-radius:12px;margin-bottom:18px;color:#3e5a60;cursor:pointer;font-size:13px}
        .rm-node-terms input{width:17px;height:17px;margin-top:1px;accent-color:#16B8C7;flex-shrink:0;cursor:pointer}
        .rm-node-error{display:block;color:#c73546;font-size:12px;margin-top:7px;font-weight:600}
        .rm-node-submit{display:flex;align-items:center;justify-content:center;gap:10px;width:100%;min-height:54px;border:0;border-radius:12px;background:linear-gradient(110deg,#0e9ba9,#16B8C7,#54d9e4);color:#002b31;font-size:14px;font-weight:900;cursor:pointer;box-shadow:0 9px 22px rgba(22,184,199,.2);transition:transform .2s ease,box-shadow .2s ease}
        .rm-node-submit:hover:not(:disabled){transform:translateY(-2px);box-shadow:0 13px 26px rgba(22,184,199,.28)}
        .rm-node-submit:disabled{opacity:.65;cursor:not-allowed}
        .rm-node-form-note{text-align:center;font-size:12px;color:#738b90;margin:12px 0 0}
        @keyframes rmNodeIn{from{opacity:0;transform:translateY(9px)}to{opacity:1;transform:translateY(0)}}
        @media(max-width:760px){.rm-node-layout{grid-template-columns:1fr}.rm-node-head{padding:17px}.rm-node-head h1{font-size:20px}.rm-node-panel{padding:17px}.rm-node-stat strong{font-size:21px}}
        @media(max-width:380px){.rm-node-head{padding:14px}.rm-node-mark{width:42px;height:42px}.rm-node-panel{padding:13px}.rm-node-stat{padding:12px}.rm-node-stat strong{font-size:19px}}
        @media(prefers-reduced-motion:reduce){.rm-node-root *{animation:none!important;transition:none!important}}
      `}</style>

      <div className="rm-node-wrap">
        <header className="rm-node-head">
          <div>
            <span className="rm-node-eyebrow">RM Crown Market / Node Management</span>
            <h1>Add New Node</h1>
            <p>Choose your node quantity and confirm your purchase securely.</p>
          </div>
          <div className="rm-node-mark" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>
          </div>
        </header>

        <main className="rm-node-layout">
          <section className="rm-node-panel" aria-label="Node purchase summary">
            <h2 className="rm-node-title"><span className="rm-node-dot" /> Node Summary</h2>
            <div className="rm-node-status">
              <div><strong>Node Security</strong><small>Safe and Secure Node</small></div>
              <span className="rm-node-pill">100%</span>
            </div>
            <div className="rm-node-stat-grid">
              <div className="rm-node-stat"><small>Total Nodes</small><strong>{count}</strong></div>
              <div className="rm-node-stat highlight"><small>Total Amount</small><strong>${(count * NODE_PRICE).toLocaleString("en-US")}</strong></div>
            </div>
            <div className="rm-node-info">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/></svg>
              <span>Each node costs <strong>$200</strong>. Your total updates automatically when you change the quantity.</span>
            </div>
          </section>

          <section className="rm-node-panel rm-node-form" aria-label="Add new node form">
            <h2 className="rm-node-title"><span className="rm-node-dot" /> Node Purchase Details</h2>
            <form onSubmit={submit}>
              <div className="rm-node-group">
                <label className="rm-node-label" htmlFor="rm-node-count">Node Count</label>
                <div className="rm-node-stepper">
                  <button type="button" aria-label="Decrease node count" onClick={() => changeCount(-1)} disabled={count <= 1 || submitting}>−</button>
                  <output id="rm-node-count" aria-live="polite">{count}</output>
                  <button type="button" aria-label="Increase node count" onClick={() => changeCount(1)} disabled={submitting}>+</button>
                </div>
                <span className="rm-node-hint">Minimum 1 node · $200 per node</span>
                {displayError("amount") && <span className="rm-node-error">{displayError("amount")}</span>}
              </div>

              <div className="rm-node-group">
                <label className="rm-node-label" htmlFor="rm-node-password">Account Password</label>
                <div className="rm-node-password">
                  <input id="rm-node-password" type={showPassword ? "text" : "password"} name="password" placeholder="Enter account password" autoComplete="current-password" value={password} onChange={(event) => { setPassword(event.target.value); setErrors((previous) => ({ ...previous, password: undefined })); }} required />
                  <button type="button" onClick={() => setShowPassword((previous) => !previous)} aria-label={showPassword ? "Hide password" : "Show password"}>{showPassword ? "Hide" : "Show"}</button>
                </div>
                {displayError("password") && <span className="rm-node-error">{displayError("password")}</span>}
              </div>

              <label className="rm-node-terms" htmlFor="rm-node-terms">
                <input id="rm-node-terms" type="checkbox" checked={accepted} onChange={(event) => { setAccepted(event.target.checked); setErrors((previous) => ({ ...previous, terms: undefined })); }} required />
                <span>I have read and accept the Terms &amp; Conditions for this node purchase.</span>
              </label>
              {displayError("terms") && <span className="rm-node-error" style={{ marginTop: -12, marginBottom: 14 }}>{displayError("terms")}</span>}
              <button className="rm-node-submit" type="submit" disabled={submitting}>{submitting ? "Processing request..." : `Add ${count} Node${count === 1 ? "" : "s"} · $${(count * NODE_PRICE).toLocaleString("en-US")}`}</button>
              <p className="rm-node-form-note">Confirm your quantity and password before submitting.</p>
            </form>
          </section>
        </main>
      </div>
    </div>
  );
};

export default Checkout;
